import React from 'react';

// iter105 — Final approved category illustration set. PNG assets live in
// /app/frontend/public/category-icons/ so they're served as static files
// with CDN cache, and the component becomes a trivial <img> wrapper.
//
// The `category` prop is the category_id from the backend (`cat_electronics`,
// `cat_mobiles`, etc.). The `size` prop controls both width and height in px
// so the caller (Homepage.js) can keep the exact rendering size it already
// uses on desktop / mobile — no visual size change vs the previous SVG icons.
//
// Sequence-of-filenames intentionally matches the numeric prefix in the ZIP
// the user approved (1_Electronics → 13_Pets). This makes swapping images
// in future a matter of dropping a new PNG in the public folder.
const ICON_MAP = {
  cat_electronics: '/category-icons/1_Electronics.png',
  cat_mobiles:     '/category-icons/2_Mobiles.png',
  cat_cars:        '/category-icons/3_Cars.png',
  cat_bikes:       '/category-icons/4_Bikes.png',
  cat_commercial:  '/category-icons/5_Transport Vehicles & Spares.png',
  cat_property:    '/category-icons/6_Property.png',
  cat_furniture:   '/category-icons/7_Furniture.png',
  cat_appliances:  '/category-icons/8_Home Appliances.png',
  cat_fashion:     '/category-icons/9_Fashion.png',
  cat_books:       '/category-icons/10_Books.png',
  cat_jobs:        '/category-icons/11_Jobs.png',
  cat_services:    '/category-icons/12_Services.png',
  cat_pets:        '/category-icons/13_Pets.png',
  // iter116 — new "Kids" primary category (positioned after Fashion in the
  // canonical order). Icon uses the same styling / size as every other tile.
  cat_kids:        '/category-icons/14_Kids.png',
};

const CategoryIcon = ({ category, size = 48 }) => {
  const src = ICON_MAP[category];
  if (!src) return null;
  // iter111 — Furniture (sofa) icon is visually thinner than the rest of the
  // approved set, so it reads as smaller on the row. Scale it up ~12% inside
  // the same tile without changing the tile size or any other icon.
  const scale = category === 'cat_furniture' ? 1.12 : 1;
  const px = Math.round(size * scale);
  return (
    <img
      src={encodeURI(src)}
      alt=""
      width={px}
      height={px}
      draggable={false}
      loading="lazy"
      style={{ display: 'block', width: `${px}px`, height: `${px}px`, objectFit: 'contain' }}
    />
  );
};

export default CategoryIcon;
